import {PageEvent} from "@angular/material/paginator";

export class Paginator<T> {

  isLoading: boolean;

  pageSize: number;
  totalPages: number;
  currentPage: number;
  totalElements: number;
  ignorePagination: boolean;
  orderBy: string;
  sorting: string;
  currPageElements: number;

  onPageChangeStart: Function;
  onPageResults: Function;
  onPageChangeEnd: Function;
  _onFetch: Function;

  constructor(options?: {ignorePagination?: boolean, pageSize?: number, orderBy?: string, sorting?: 'ASC' | 'DESC'}) {
    this.currentPage = 0;
    this.totalPages = 1;
    this.pageSize = options?.pageSize || 20;
    this.totalElements = 0;
    this.ignorePagination = options?.ignorePagination;
    this.orderBy = options?.orderBy;
    this.sorting = options?.sorting;
    this.isLoading = true;

    // Override page size if ignoring pagination
    if (this.ignorePagination) {
      this.pageSize = 200;
    }
  }

  /*next() {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
      this._onFetch();
    }
  }

  previous() {
    if (this.currentPage > 0) {
      this.currentPage--;
      if (this.onPageChanged) {
        this._onFetch();
      }
    }
  }*/

  async pageChanged(pageEvent: PageEvent) {
    this.currentPage = pageEvent.pageIndex;
    await this.refresh();
  }

  async refresh() {
    await this._onFetch();
  }

}
